import {Component, OnInit, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import {FieldComponent} from "../field/field.component";
import {Nir} from "./nir";

@Component({
  selector: 'taxihandgo-nir',
  templateUrl: './nir.component.html',
  styleUrls: ['./nir.component.scss']
})
export class NirComponent implements OnInit {

  private _value: Nir = new Nir();

  @ViewChild("nir") nir: FieldComponent;
  @ViewChild("key") key: FieldComponent;
  @Output() valueChange = new EventEmitter();
  public nirIsValid: boolean = false;
  public dirty: boolean = false;
  constructor() { }

  ngOnInit() {
  }

  @Input()
  get value(){
    return this._value;
  }

  set value(value: Nir){
    this._value = value;
  }

  update(){
    this.value = new Nir(this.nir.value, this.key.value);
    this.nirIsValid = this.value.isValid();
    this.dirty = true;
    this.valueChange.emit(this._value);
  }

  public onPaste(event: any){
    if (event.data && event.data.length == 15){
      this.key.value = event.data.substr(13, 2);
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/nir/nir.component.ts